import { Button, styled, useTheme } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { Link } from "react-router-dom";
import ArrowLeftIcon from "../../../icons/ArrowLeftIcon";

const HyroBreadcrumbs = ({
  breadcrumbs = [],
  baseUrl = "",
  onBreadcrumbClick,
  backButton,
  onBackClick
}) => {
  const theme = useTheme();

  if (backButton) {
    return (
      <Button
        data-testid="breadcrumbs-back-button"
        onClick={onBackClick}
        startIcon={<ArrowLeftIcon size={"20"} stroke={theme.palette.text[800]} />}
        sx={{ ml: "-12px", px: "12px", lineHeight: "20px", color: theme.palette.text[800] }}>
        {backButton}
      </Button>
    );
  }

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ ".MuiBreadcrumbs-separator": { ...theme.typography.body1 } }}>
      {breadcrumbs.map((breadcrumb, index) => {
        if (!breadcrumb) return null;
        const isLastBreadcrumb = breadcrumbs.length - 1 === index;
        const path = index === 0 ? "" : [...breadcrumbs].slice(1, index + 1).join("/");

        return (
          <StyledLink
            key={"breadcrumb-" + breadcrumb}
            underline="hover"
            color="inherit"
            to={`${baseUrl}${path.toLowerCase().split(" ").join("-")}`}
            style={{ pointerEvents: isLastBreadcrumb ? "none" : "" }}
            onClick={onBreadcrumbClick}
          >
            <Typography
              sx={{ lineHeight: "24px" }}
              variant="body2"
              color={`text.${isLastBreadcrumb ? "primary" : "secondary"}`}
              data-testid={`breadcrumb-${breadcrumb}`}
            >
              {breadcrumb}
            </Typography>
          </StyledLink>
        );
      })}
    </Breadcrumbs>
  );
};

const StyledLink = styled(Link)(({ theme }) => ({
  "textDecoration": "none",
  "display": "flex",
  "&:hover": {
    textDecoration: "underline",
    textDecorationColor: theme.palette.text[700]
  }
}));

export default HyroBreadcrumbs;
